export default __webpack_public_path__ + "static/media/1-6.fe6fdce5.png";